import {FC} from 'react'
import {Link} from 'react-router-dom'
import type {GetReportList, ProcedureInfoProps} from './types'

// @ts-ignore
import ListGroup from 'jbc-front/components/ListGroup'
// @ts-ignore
import {EMPLOYMENT} from 'procedureStatuses/reportList/common'

export const getReportList: GetReportList = function* ({employmentInsuranceJoined}) {
  if (employmentInsuranceJoined) {
    yield {
      num: 'r511',
      title: '育児休業給付金／出生後休業支援給付金支給申請書',
      editable: true,
      type: EMPLOYMENT,
    }
  }
}

const ProcedureInfo: FC<ProcedureInfoProps> = ({procedureStatus}) => (
  <ListGroup>
    <ListGroup.Title>添付ファイル</ListGroup.Title>
    <ListGroup.Item as={Link} to={`/procedure_statuses/${procedureStatus.id}/attachments`}>
      添付ファイルの確認・編集
    </ListGroup.Item>
  </ListGroup>
)

export default {getReportList, ProcedureInfo}
